import { render, staticRenderFns } from "./CadastroHion.vue?vue&type=template&id=2d34d426&"
import script from "./CadastroHion.vue?vue&type=script&lang=js&"
export * from "./CadastroHion.vue?vue&type=script&lang=js&"
import style0 from "./CadastroHion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports